import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MortgageSupTypeStrings } from '@core/util/file';
import { ICON } from '@core/util/icon';
import { MortgageDocumentTypeTag, Tags } from '@core/util/tags';
import {
	MatterFile,
	MortgageDocumentSubType,
	MortgageMatterFile,
} from '@models/matter-file';
import { SnackbarService } from '@services/ui/snackbar.service';
import { MatterUploadedFilesDispatch } from '@state/matter/uploaded-files/matter-uploaded-files.dispatch';

export interface EditCategoryModalData {
	file: MortgageMatterFile;
}

interface SubType {
	type: MortgageDocumentSubType;
	friendlyType: string;
}

@Component({
	selector: 'app-edit-category-modal',
	templateUrl: './edit-category-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class EditCategoryModalComponent {
	public subTypes = Object.values(MortgageDocumentSubType).reduce(
		(acc, type) => {
			acc.push({
				type,
				friendlyType: MortgageSupTypeStrings[type] ?? type,
			});
			return acc;
		},
		[] as SubType[],
	);
	public selectedSubType: MortgageDocumentSubType;
	public file: MatterFile;
	public ICON = ICON;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: EditCategoryModalData,
		private dialogRef: MatDialogRef<EditCategoryModalComponent>,
		private matterUploadedFilesDispatch: MatterUploadedFilesDispatch,
		private snackbarService: SnackbarService,
	) {
		this.file = data.file;
		this.selectedSubType = data.file.systemTags
			?.find((tag) => tag.includes(Tags.MORTGAGE_DOC_TYPE))
			?.split(':')?.[1] as MortgageDocumentSubType;
	}

	save() {
		const newSystemTags = this.file.systemTags.filter((tag) => {
			const prefix = tag.split(':')[0];
			return prefix !== Tags.MORTGAGE_DOC_TYPE;
		});

		newSystemTags.push(MortgageDocumentTypeTag(this.selectedSubType));
		this.matterUploadedFilesDispatch.UpdateFileSystemTags(
			this.file.id,
			newSystemTags,
		);
		this.snackbarService.openSnackBar({
			text: 'Category type update',
			type: 'success',
			icon: ICON.CIRCLE_CHECK,
		});
		this.dialogRef.close();
	}

	close() {
		this.dialogRef.close();
	}
}
